(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/flows/create-fundraising-page/views/wait/template', '<div\n' + '  class="create-flow"\n' + '  data-ng-class="{processing: ui.processing}"\n' + '  tabindex="0"\n' + '  aria-label="Please wait"\n' + '>\n' + '  <h2 class="create-flow_title">Please wait ...</h2>\n' + '\n' + '  <div class="create-flow_waiting">\n' + '    <div class="create-flow_waiting-spinner" data-ng-style="{color: ui.primaryColor}"></div>\n' + '  </div>\n' + '</div>\n' + '');
}]);
})();